import React from "react";
import { Button, HStack } from "@chakra-ui/react";
export type BillingInterval = "month" | "year";
export const billingPrice = (
  type: string,
  tier: string,
  interval: BillingInterval,
) => {
  const cents = type === "all_access_v3" ? 29999 : tier === "paid" ? 999 : 3999;
  const amount = interval === "year" ? Math.round(cents * 12 * 0.8) : cents;
  return `$${(amount / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}/${interval === "year" ? "year" : "month"}`;
};
export const BillingIntervalToggle = ({
  value,
  onChange,
  disabled = false,
}: {
  value: BillingInterval;
  onChange: (value: BillingInterval) => void;
  disabled?: boolean;
}) => (
  <HStack
    role="group"
    aria-label="Billing period"
    spacing={1}
    p={1}
    borderWidth="1px"
    borderRadius="lg"
    width="fit-content"
  >
    <Button
      size="sm"
      isDisabled={disabled}
      aria-pressed={value === "month"}
      variant={value === "month" ? "solid" : "ghost"}
      onClick={() => onChange("month")}
    >
      Monthly
    </Button>
    <Button
      size="sm"
      isDisabled={disabled}
      aria-pressed={value === "year"}
      colorScheme={value === "year" ? "blue" : undefined}
      variant={value === "year" ? "solid" : "ghost"}
      onClick={() => onChange("year")}
    >
      Annual · Save 20%
    </Button>
  </HStack>
);
